import { connect } from "react-redux";
import ValetChartListView from "./ValetChartListView";
import { bindActionCreators } from "redux";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import {getAllValetRaisedTickets, getValetOpsRespond, updateStatusValetHead} from "services/redux/Valet/Project/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    allRaisedTicketsList: state.CreateProject.allRaisedTicketsList,
    getResponseFromValetOps: state.CreateProject.getResponseFromValetOps,
    statusUpdate: state.CreateProject.statusUpdate,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        documentUploadUrlPublic,
        getAllValetRaisedTickets,
        getValetOpsRespond,
        updateStatusValetHead
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ValetChartListView);